import React, { useState } from 'react';
import { HardDrives } from '@phosphor-icons/react';
import { Namespace } from '../../../../types/namespace';
import { Item } from './Item';
import { ActionMenu } from './ActionMenu';

interface VectorMemoryItemProps {
  namespace: Namespace;
  onEdit: (ns: Namespace) => void;
  onDelete: (ns: Namespace) => void;
  isNested?: boolean;
}

export const VectorMemoryItem: React.FC<VectorMemoryItemProps> = ({
  namespace,
  onEdit,
  onDelete,
  isNested = true,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Item
        icon={<HardDrives size={16} />}
        label={namespace.name}
        isNested={isNested}
        isMenuOpen={Boolean(anchorEl)}
        onClick={() => onEdit(namespace)}
        onMenuClick={anchor => {
          setAnchorEl(anchor);
        }}
      />
      <ActionMenu
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onEdit={() => {
          setAnchorEl(null);
          onEdit(namespace);
        }}
        onDelete={() => {
          setAnchorEl(null);
          onDelete(namespace);
        }}
        showEdit={true}
      />
    </>
  );
};
